import React from "react";

const industryList = [
  {
    title: "Manufacturers",
    icon: "fas fa-industry",
    description: "Streamlining production processes with innovative tech solutions.",
    delay: "100",
  },
  {
    title: "Import / Export",
    icon: "fas fa-ship",
    description: "Optimizing supply chain management for seamless operations.",
    delay: "300",
  },
  {
    title: "Real Estate",
    icon: "fas fa-building",
    description: "Driving property management with cutting-edge software.",
    delay: "500",
  },
  {
    title: "Wholesalers + Retailers",
    icon: "fas fa-store",
    description: "Boosting sales and inventory management for retail businesses.",
    delay: "700",
  },
  {
    title: "Construction",
    icon: "fas fa-hard-hat",
    description: "Enhancing project tracking and cost estimation for builders.",
    delay: "100",
  },
  {
    title: "School + University",
    icon: "fas fa-graduation-cap",
    description: "Modernizing education with digital learning management tools.",
    delay: "300",
  },
  {
    title: "Health Care",
    icon: "fas fa-hospital",
    description: "Integrating data-driven solutions for improved patient care.",
    delay: "500",
  },
  {
    title: "Financial Institution",
    icon: "fas fa-university",
    description: "Empowering banking and financial services with secure technology.",
    delay: "700",
  },
];

const Industries = () => {
  return (
    <div className="container-fluid py-5" id="industries">
      <div className="container py-5">
        {/* Section Header */}
        <div
          className="section-title text-center mb-5"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h5 className="sub-title" style={{ color: "#A71717" }}>
            INDUSTRIES
          </h5>
          <h1 className="display-5 mb-4" style={{ color: "#A71717" }}>
            Industries We Serve
          </h1>
          <p className="mb-0 text-muted">
            We provide comprehensive solutions across various sectors
          </p>
        </div>

        {/* Industry Cards */}
        <div className="row g-4">
          {industryList.map((industry, i) => (
            <div
              className="col-lg-3 col-md-6"
              key={i}
              data-aos="fade-up"
              data-aos-delay={industry.delay}
            >
              <div className="service-item text-center p-4 rounded shadow-sm bg-white h-100">
                <div
                  className="service-icon bg-light rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center"
                  style={{ width: "80px", height: "80px" }}
                >
                  <i className={`${industry.icon} fa-2x`} style={{ color: "#A71717" }}></i>
                </div>
                <h5 className="text-dark">{industry.title}</h5>
                <p className="text-muted">{industry.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Industries;
